import React, { useState } from 'react';
import { FormControl, InputLabel, Select, MenuItem, TextField } from '@mui/material';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { disponibiliteOptions as defaultOptions } from './constants/options';

const DisponibilitePicker = ({
  label = "Disponibilité",
  value,
  onChange,
  error,
  helperText,
  required = false,
  options = defaultOptions
}) => {
  const [selectedOption, setSelectedOption] = useState('');

  const handleSelectChange = (val) => {
    setSelectedOption(val);

    if (val === 'immédiat') {
      onChange(new Date());
    } else if (val === '1 mois') {
      const date = new Date();
      date.setMonth(date.getMonth() + 1);
      onChange(date);
    } else if (val === '3 mois') {
      const date = new Date();
      date.setMonth(date.getMonth() + 3);
      onChange(date);
    } else {
      onChange(null); 
    }
  };

  return (
    <>
      <FormControl fullWidth error={!!error} required={required}>
        <InputLabel>{label}</InputLabel>
        <Select
          value={selectedOption}
          onChange={(e) => handleSelectChange(e.target.value)}
          label={label}
        >
          {options.map((option) => (
            <MenuItem key={option.value} value={option.value}>
              {option.label}
            </MenuItem>
          ))}
        </Select>
      </FormControl>

      {selectedOption === 'autre' && (
        <DatePicker
          label="Sélectionner une date"
          value={value instanceof Date ? value : null}
          onChange={onChange}
          renderInput={(params) => (
            <TextField
              {...params}
              fullWidth
              error={!!error}
              helperText={helperText}
              sx={{ mt: 2 }}
              required={required}
            />
          )}
        />
      )}
    </>
  );
};

export default DisponibilitePicker;
